import React from "react"

import * as S from "./shop-cards.styles"
import { Grid } from "@mui/material"
import Container from "@mui/material/Container"
import Check from "../../images/check-gift-card.png"
import Give from "../../images/give-gift-card.png"

const ShopCards = ({ title, text }) => {
  return (
    <S.Background>
      {title && <S.Title>{title}</S.Title>}
      <S.Flex>
        <S.Dash />
        {text && <S.Text>{text}</S.Text>}
        <S.Dash />
      </S.Flex>
      <Container maxWidth="md">
        <S.GridContainer container spacing={10}>
          <Grid item xs={12} md={6}>
            <a
              href="https://www.toasttab.com/halftimepizzaboston/giftcards"
              target="_blank"
            >
              <S.Image img={Give} />
            </a>
          </Grid>
          <Grid item xs={12} md={6}>
            <a
              href="https://www.toasttab.com/halftimepizzaboston/findcard"
              target="_blank"
            >
              <S.Image img={Check} />
            </a>
          </Grid>
        </S.GridContainer>
      </Container>
    </S.Background>
  )
}

export default ShopCards
